﻿'use strict'

function add() {
    $(".scrollable").mCustomScrollbar({ theme: "minimal-dark" });
    // for kendo-tabs
    $(".job-layout .k-content").mCustomScrollbar({ theme: "minimal-dark" });
}

module.exports = {
    add: add
};